module.exports = __webpack_public_path__ + "7c7b780f12c244d86726703a530f455c.svg";